<sz-modal
  [width]="'400px'"
  [height]="null"
  [showTitle]="false"
  [hideOnOutsideClick]="false"
  [showCloseButton]="false"
  [(visible)]="visible"
  (onHidden)="handleHidden()"
  >
  <div class="flex flex-col items-center px-10 py-8 gap-6">
    <div class="flex flex-col items-center">
      <img src="../../../../assets/icons/error.svg"
        [width]="80"
        [height]="80"
        alt="icon-alert"
        />
      <label class="mt-4 mb-2 text-brand-500 font-medium text-2xl text-center">
        Attention
      </label>
      @if (message) {
        <p class="text-base font-normal text-brand-500 text-center min-w-[20rem]">
          {{message}}
        </p>
      }
      @if (messageHtml) {
        <div class="text-base font-normal text-brand-500 html-content" [innerHTML]="messageHtml | safeHtml"></div>
      }
    </div>
    <div class="flex flex-col items-center gap-3 w-full">
      <button class="sz-btn-primary h-[48px] w-[200px]" (click)="handleAction()">
        {{blocking ? 'OK' : (isAlert ? 'Close' : (buttonText ?? 'Cancel'))}}
      </button>
      @if (!blocking && !isAlert) {
        <button class="text-sm font-medium text-neutral-500 hover:text-neutral-700 underline transition-colors" (click)="handleDismiss()">
          Ignore
        </button>
      }
    </div>
  </div>
</sz-modal>
